// Single source of truth for license-number normalization lives in the shared
// DI lib; re-exported here so existing card imports/tests keep their path.
import { normalizeLicenseNumber } from 'src/lib/documentIntelligence'

export { normalizeLicenseNumber }

interface LicenseNumberComparisonInput {
  extractedLicenseNumber?: string | null
  applicantLicenseNumber?: string | null
}

export const isLicenseNumberMismatch = ({
  extractedLicenseNumber,
  applicantLicenseNumber,
}: LicenseNumberComparisonInput): boolean => {
  if (!extractedLicenseNumber) return false

  const normalizedExtracted = normalizeLicenseNumber(extractedLicenseNumber)
  const normalizedApplicant = normalizeLicenseNumber(applicantLicenseNumber)

  return normalizedExtracted !== normalizedApplicant
}
